export default __webpack_public_path__ + "static/media/default_texture.6536ebc0.png";